import { useState } from "react";
import { css } from "@emotion/react";

import Modal from "react-modal";

type Section = {
  title: string;
  id: string;
};

export const titles = [
  "Intro / はじめに",
  "Episode / あらすじ",
  "Chart / 相関図",
  "Original / 原作",
  "Special / フォトギャラリー",
];

export const titleToID = (title: string) => title.split(" / ")[0].toLowerCase();

const sections: Section[] = [
  {
    title: "Top",
    id: "top",
  },
  ...titles.map((title) => ({
    title,
    id: titleToID(title),
  })),
];

const modalStyleProp: Modal.Styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(208, 1, 18, 0.8)",
    transition: "opacity 200ms ease-in-out",
  },
};

const HumburgerMenu: React.FC = ({}) => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * クリック時対象のセクションにスクロールする
   */
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <div css={humburgerWrapperStyle}>
        <img
          onClick={() => setIsOpen(true)}
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/humburger.png"}
          alt="humburger-menu"
          css={humburgerImgStyle}
        />
      </div>
      <Modal isOpen={isOpen} style={modalStyleProp} css={modalStyle}>
        <img
          onClick={() => setIsOpen(false)}
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/modal-close.png"}
          alt="close"
          css={closeButtonStyle}
        />
        <div css={menuContainerStyle}>
          {sections.map((section) => (
            <div
              key={section.id}
              onClick={() => {
                scrollToSection(section.id);
                setIsOpen(false);
              }}
              css={menuItemStyle}
            >
              {section.title}
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

const primaryColor = "#D90012";
const spSize = 768;

const humburgerWrapperStyle = css`
  position: fixed;
  top: 2%;
  right: 2%;
  width: 40px;

  @media (max-width: ${spSize}px) {
    width: 30px;
  }
`;

const humburgerImgStyle = css`
  width: 100%;
  height: auto;

  &:hover {
    cursor: pointer;
  }
`;

const modalStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${primaryColor};

  &:focus-visible {
    outline: none;
  }
`;

const closeButtonStyle = css`
  position: absolute;
  top: 5%;
  right: 5%;
  width: 40px;
  height: 40px;

  @media (max-width: ${spSize}px) {
    width: 30px;
    height: 30px;
  }

  &:hover {
    cursor: pointer;
  }
`;

const menuContainerStyle = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-family: MyFont;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
  }
`;

const menuItemStyle = css`
  color: white;
  margin-top: 20px;

  &:hover {
    cursor: pointer;
  }
`;

export default HumburgerMenu;
